<template>
  <vx-card>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <div class="p-6">
        <div class="vx-col sm:w-3/6" style="padding: 10px 0;">
          <drop-zone :text="`Upload Avatar`" :accept="`image/*`" :displayAs="'image'" v-model="form.profilePicture" />
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </div>

        <ValidationProvider rules="required|min:5" name="name" v-slot="{ errors }" tag="div">
          <vs-input label="Name" v-model="form.name" class="mt-5 w-full" />
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider v-if="!isEdit" rules="required|min:5|max:12" name="password" v-slot="{ errors }" tag="div">
          <vs-input type="password" label="Password" v-model="form.password" class="mt-5 w-full" />
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider rules="required|email" name="email" v-slot="{ errors }" tag="div">
          <vs-input label="Email Address" v-model="form.emailAddress" class="mt-5 w-full" />
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider rules="required" name="status" v-slot="{ errors }" tag="div">
          <vs-select v-model="form.generalStatus" label="Status" class="mt-5 w-full">
            <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in status" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider rules="required" name="roleId" v-slot="{ errors }" tag="div">
          <vs-select v-model="form.roleId" label="Role" class="mt-5 w-full">
            <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in adminRoles" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="handleSubmit" :disabled="invalid">Submit</vs-button>
      </div>
    </ValidationObserver>
  </vx-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DropZone from '@/components/DropZone';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DropZone,
  },
  data() {
    return {
      form: {
        profilePicture: '',
        name: '',
        password: '',
        emailAddress: '',
        generalStatus: '',
        roleId: undefined
      },
    };
  },
  computed: {
    status() {
      return [
        { text: 'Active', value: 'ACTIVE' },
        { text: 'Disabled', value: 'DISABLED' },
      ];
    },
    ...mapState({
      adminRoles: ({ adminRoleManagement }) => adminRoleManagement.adminRoles || [],
      admin: ({ userManagement }) => userManagement.admin,
      addAdminState: ({ userManagement }) => userManagement.apiState.addAdmin,
      updateAdminState: ({ userManagement }) => userManagement.apiState.updateAdmin,
    }),
    routeName() {
      return this.$route.name;
    },
    adminUserId() {
      return this.$route.params.id || undefined;
    },
    isEdit() {
      return Boolean(this.routeName === 'admin-edit' && this.adminUserId);
    },
  },
  methods: {
    ...mapActions({
      getAdminRoles: "adminRoleManagement/getAdminRoles",
      addAdmin: 'userManagement/addAdmin',
      getAdmin: 'userManagement/getAdmin',
      updateAdmin: 'userManagement/updateAdmin',
    }),
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        return this.submit();
      }

      return this.$vs.dialog({
        color: 'danger',
        title: `Validation Error!`,
        text: 'There is a error in this form',
      });
    },
    async submit() {
      return this.$vs.dialog({
        color: 'primary',
        title: `Are you sure submit?`,
        text: 'Continue submit',
        acceptText: 'Yes',
        accept: () => {
          if (this.isEdit) {
            return this.updateAdmin({ 
              id: this.adminUserId, 
              body: { 
                ...this.form,
                role: { id: this.form.roleId }
              },
            });
          }
          return this.addAdmin({
            ...this.form,
          });
        },
      });
    },
  },
  async mounted() {
    await this.getAdminRoles()

    if (this.isEdit) {
      this.getAdmin(this.adminUserId).then(() => {
        this.form = {
          ...this.form,
          name: this.admin.name,
          emailAddress: this.admin.emailAddress,
          profilePicture: this.admin.profilePicture,
          generalStatus: this.admin.generalStatus,
          roleId: this.admin.roleId,
        };
      });
    }
  },
  watch: {
    'addAdminState.success'(value) {
      if (value) {
        this.$vs.notify({
          title: 'Success create!',
          color: 'success',
          position: 'top-center',
        });
        this.$router.push({ name: 'admin' });
      }
    },
    'addAdminState.error'(error) {
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });
      }
    },
    'updateAdminState.success'(value) {
      if (value) {
        this.$vs.notify({
          title: 'Successful update!',
          color: 'success',
          position: 'top-center',
        });
      }
    },
    'updateAdminState.error'(error) {
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
